<template>
	<div class="flex flex-col gap-0.5 bg-white shadow sm:rounded-lg p-4 m-4">
		<div>
			<div class="flex items-center justify-between w-full gap-2 mb-4">
				<PageLabel :helpPageName="'Assessments'">Assessments</PageLabel>
				<div class="flex flex-row items-center gap-2">
					<button class="btn" id="btnNewUser" @click="newAssessment()" v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Create)">
						New Assessment
					</button>
				</div>
			</div>
			<DataTable
				:value="assessmentsList"
				responsiveLayout="scroll"
				:row-hover="true"
				:paginator="true"
				:rows="tablePaginator == null ? 10 : tablePaginator.rows"
				:first="tablePaginator == null ? 0 : tablePaginator.first"
				:page="tablePaginator == null ? 0 : tablePaginator.page"
				@page="pageChanged($event)"
				paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				:rowsPerPageOptions="[10, 20, 50]"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
				dataKey="id"
				v-model:filters="usersFilters"
				:loading="loading1"
				id="dtAssessmentList"
			>
				<template #header>
					<div class="p-d-flex p-jc-between">
						<Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined" @click="usersFilters['global'].value = null" />
						<span class="p-input-icon-left">
							<i class="pi pi-search" />
							<InputText v-model="usersFilters['global'].value" id="UserKeywordSearch" placeholder="Keyword Search" />
						</span>
					</div>
				</template>
				<template #empty> No assessment found. </template>
				<template #loading> Loading assessment data. Please wait. </template>
				<Column field="assessmentName" header="Assessment Name" :sortable="true" style="flex: 0 0 30%">
					<template #body="{ data }">
						<div class="w-full" @click="selectAssessment(data)">{{ data.assessmentName }}</div>
					</template>
					<template #filter="{ filterModel }">
						<InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
					</template>
				</Column>
				<Column field="assessmentNumber" header="Assessment Number" :sortable="true" style="flex: 0 0 30%">
					<template #body="{ data }">
						<div class="w-full" @click="selectAssessment(data)">{{ data.assessmentNumber }}</div>
					</template>
					<template #filter="{ filterModel }">
						<InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Number" />
					</template>
				</Column>
				<Column field="devStageTxt" header="Development Stage" :sortable="true" style="flex: 0 0 30%">
					<template #body="{ data }">
						<div class="w-full" @click="selectAssessment(data)">{{ data.devStageTxt }}</div>
					</template>
				</Column>
				<Column field="electronicLabNumber" header="Electronic Lab Number" :sortable="true" style="flex: 0 0 30%">
					<template #body="{ data }">
						<div class="w-full" @click="selectAssessment(data)">{{ data.electronicLabNumber }}</div>
					</template>
					<template #filter="{ filterModel }">
						<InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Electronic Lab No" />
					</template>
				</Column>
				<Column field="collaboratorsListTable" header="Assessment Collaborators" style="flex: 0 0 45%">
					<template #body="{ data }">
						<div class="w-full">
							{{ data.collaboratorsListTable }}
						</div>
					</template>
					<template #filter="{ filterModel }">
						<InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Collaborators" />
					</template>
				</Column>
				<Column field="comments" header="Comments" :sortable="true" style="flex: 0 0 5%">
					<template #body="{ data }">
						<div class="w-full">{{ data.comments }}</div>
					</template>
					<template #filter="{ filterModel }">
						<InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Comment Contents" />
					</template>
				</Column>

				<Column field="id" header="Actions" style="width: 11%" styleClass="tdLessPadding">
					<template #body="slotProps"
						><span style="cursor: pointer"
							><FontAwesomeIcon
								:icon="['far', 'pen']"
								title="Modify"
								@click="editAssessment(slotProps.data)"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)" /></span
						><span style="cursor: pointer"
							><FontAwesomeIcon
								:icon="['far', 'info-circle']"
								title="View"
								@click="editAssessment(slotProps.data)"
								class="ml-2"
								v-show="!SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
						/></span>
						<span style="cursor: pointer"
							><FontAwesomeIcon
								:icon="['far', 'trash']"
								title="Delete"
								@click="deleteAssessment(slotProps.data)"
								class="ml-2"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Delete)"
						/></span>
						<!-- <span style="cursor: pointer"
							><FontAwesomeIcon
								:icon="['far', 'chart-line']"
								title="Result"
								@click="resultAssessment(slotProps.data)"
								class="ml-2"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
						/></span>  -->
					</template></Column
				>
			</DataTable>
		</div>
		<div v-if="showDialog">
			<assessmentEdit :assessment="assessment" @cancel="cancel()" @save="save()" />
		</div>

		<Dialog v-model:visible="showDialogDelete" :modal="true" style="width: 35vw" :closable="false" contentStyle="overflow:visible">
			<template #header><h1>Delete Assessment</h1> </template>
			<FormCard>
				<I2FormRow class="mt-6">
					<h1>Are you sure you would like to delete selected Assessment?</h1>
				</I2FormRow>
			</FormCard>
			<template #footer>
				<I2FormRow right>
					<Button label="Cancel" class="inverted mr-4" @click="showDialogDelete = false" right />
					<Button label="Delete" class="ml-4" @click="deleteAssessmentOK()" right />
				</I2FormRow>
			</template>
		</Dialog>
	</div>
</template>
<script setup lang="ts">
import { ref, onMounted, reactive, Prop } from "vue"
import Dialog from "primevue/dialog"
import { ApiClient, Assessment, AssessmentCollaboratorPut, AssessmentCollaborators } from "../../entities/NSwagGenerated"
import { EventBus } from "../eventBus"

import { FilterMatchMode, FilterOperator } from "@primevue/core/api"
import Button from "primevue/button"
import InputText from "primevue/inputtext"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
import PageLabel from "./pageLabel.vue"
import DataTable, { DataTableRowEditCancelEvent } from "primevue/datatable"
import Column from "primevue/column"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faInfoCircle, faTrash, faPen, faChartLine, faBookmark, faBookmarkSlash } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(faTrash, faPen, faInfoCircle, faChartLine, faBookmark, faBookmarkSlash)
import assessmentEdit from "./assessmentEdit.vue"

import { useRouter, useRoute } from "vue-router"
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const assessmentsList = ref()
let showDialog = ref(false)
let showDialogDelete = ref(false)
let tablePaginator: any | null = null
const selectedAssessmentId = ref()
let loading1: any = null
const router = useRouter()
const route = useRoute()
let assessment = new Assessment()

let usersFilters = reactive({
	global: { value: null, matchMode: FilterMatchMode.CONTAINS },
	assessmentName: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	assessmentNumber: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	developmentStage: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	electronicLabNumber: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	assessmentCollaborators: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	collaboratorsListTable: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	comments: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
})

onMounted(() => {
	// if (localStorage.getItem("assessmentListFilter")) {
	// 	usersFilters = JSON.parse(localStorage.getItem("assessmentListFilter")!)
	// }

	// 	type: "assessment",
	// 	label: "",
	// 	id: route.query.subProjectId,
	// })
	refresh()
})
function resultAssessment(assessment: Assessment) {}

function save() {
	showDialog.value = false
	refresh()
}
function cancel() {
	selectedAssessmentId.value = null
	showDialog.value = false
	refresh()
}
function newAssessment() {
	selectedAssessmentId.value = null
	assessment = new Assessment()
	assessment.subProjectId = route.query.subProjectId
	showDialog.value = true
}
function deleteAssessment(data: Assessment) {
	selectedAssessmentId.value = data.id
	showDialogDelete.value = true
}
function deleteAssessmentOK() {
	apiClient.assessmentDelete(selectedAssessmentId.value).then(
		(result) => {
			refresh()
			showDialogDelete.value = false
		},
		(err) => {
			throw err
		}
	)
}
function selectAssessment(data: Assessment) {
	selectedAssessmentId.value = data.id
	// 	type: "assessment",
	// 	label: data.assessmentName,
	// 	id: data.id,
	// })
	router.push({ name: "assessment", query: { assessmentId: data.id } })
}
function editAssessment(data: any) {
	assessment = data
	showDialog.value = true
}

function bookmarkAssessment(data: any, value: boolean) {
	function bookmarkAssessment(data: any, value: boolean) {
		assessment = data
		assessment.isBookmarked = value

		apiClient.postassessmentonly(assessment).then(
			(result) => {
				refresh()
			},
			(err) => {
				throw err
			}
		)

		// let assessmentAndCollaborators = new AssessmentCollaboratorPut()
		// assessmentAndCollaborators.collaborators = selectedPersons.value
		// assessmentAndCollaborators.assessment = assessment
		// assessmentAndCollaborators.assessment.developmentStageId = selectedDevelopmentStage.value.id
		// assessmentAndCollaborators.assessment.productNameId = selectedProductName.value.id
		// apiClient.assessmentPost(assessmentAndCollaborators).then((res) => {
		// 	emit("save")
		// })
	}

	function collaboratorsList(list: any) {
		let collaboratorsList = new Array<string>()
		list.forEach((el: AssessmentCollaborators) => {
			collaboratorsList.push(el.person.firstName + " " + el.person.lastName)
		})
		return collaboratorsList.join(",")
	}

	function pageChanged(ev: Event) {
		tablePaginator = ev
		localStorage.setItem("projectListPaginate", JSON.stringify(ev))
	}

	function applyFilter(ev: Event) {
		localStorage.setItem("assessmentListFilter", JSON.stringify(usersFilters))
	}
	function refresh() {
		apiClient!.bookmarkedAssessmentList().then(
			(result) => {
				//console.log("tiger", result)
				assessmentsList.value = result
				assessmentsList.value.forEach((el: any) => {
					if (el.isBookmarked == null) {
						if (el.isBookmarked == null) {
							el.isBookmarked = false
						}
						el.devStageTxt = el.developmentStage.valueTxt
						el.collaboratorsListTable = collaboratorsList(Object.values(el.assessmentCollaborators))
					}
				})
			},
			(err) => {
				throw err
			}
		)
	}
}
</script>
